import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import { useDevanningStore } from './devanningStore'

import { inboundV2Service } from '@/services'
import {
  CargoMarksGroup,
  MarkProgress,
  PalletsGroup,
  PendingPallet,
  ScanRecord
} from '@/services/InboundV2Service'

interface ScanProgressState {
  loading: boolean
  progress?: MarkProgress
  markList: MarkProgress[]
  recordList: ScanRecord[]
  palletList: PendingPallet[]
  palletsGroup: PalletsGroup[]
  cargoMarksGroup: CargoMarksGroup[]
}

interface ScanProgressActions {
  fetchProgress: (scannedMarkId?: number) => Promise<void>
}

type ScanProgressStore = ScanProgressState & ScanProgressActions

const initialState: ScanProgressState = {
  loading: false,
  markList: [],
  recordList: [],
  palletList: [],
  palletsGroup: [],
  cargoMarksGroup: []
}

export const useScanProgressStore = create<ScanProgressStore>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        // 获取扫描进度
        fetchProgress: async (scannedMarkId?: number) => {
          const masterBill = useDevanningStore.getState().masterBill
          if (masterBill) {
            set({
              loading: true
            })
            const { success, data } = await inboundV2Service.progress(
              masterBill.id,
              scannedMarkId
            )
            if (success) {
              set({
                progress: data?.cargoMarkProgress,
                markList: data?.cargoMarksProgress ?? [],
                recordList: data?.records ?? [],
                palletList: data?.pallets ?? [],
                palletsGroup: data?.palletsGroup ?? [],
                cargoMarksGroup: data?.cargoMarksGroup ?? []
              })
            }
            set({
              loading: false
            })
          }
        }
      }),
      {
        name: 'scan-progress-storage',
        partialize: (state) => ({
          progress: state.progress
        })
      }
    )
  )
)

export const useScanProgressState = () => {
  const loading = useScanProgressStore((state) => state.loading)
  const progress = useScanProgressStore((state) => state.progress)
  const recordList = useScanProgressStore((state) => state.recordList)
  const palletList = useScanProgressStore((state) => state.palletList)
  const palletsGroup = useScanProgressStore((state) => state.palletsGroup)
  const cargoMarksGroup = useScanProgressStore((state) => state.cargoMarksGroup)

  return {
    loading,
    progress,
    recordList,
    palletList,
    palletsGroup,
    cargoMarksGroup
  }
}

export const useScanProgressActions = () => {
  const fetchProgress = useScanProgressStore((state) => state.fetchProgress)
  return {
    fetchProgress
  }
}
